import { getHostsSelectors } from '@/modules/host/slice';
import { lobbySliceActions } from '@/modules/lobby/slice';
import { userSliceActions } from '@/modules/main/slice/user';
import { RootState } from '@/store/store';
import { Epic } from 'redux-observable';
import { concat, filter, switchMap } from 'rxjs';

export const featureOrderEpic: Epic = (action$, store$) =>
    action$.pipe(
        filter(userSliceActions.updateFeatureOrder.match),
        switchMap(action => {
            console.log(`update order`, action.payload);
            const outs = [];
            const state = store$.value as unknown as RootState;
            const hosts = getHostsSelectors.selectAll(state);
            const FeatureOrder = action.payload;
            const hallGameTypeMap = hosts
                .sort((a, b) => {
                    let orderA = 10000;
                    let orderB = 10000;
                    if (a.IsTest) {
                        orderA = 20000;
                    }
                    if (b.IsTest) {
                        orderB = 20000;
                    }
                    if (FeatureOrder) {
                        if (FeatureOrder.indexOf(a.GameType) >= 0) {
                            orderA += FeatureOrder.indexOf(a.GameType) * 100;
                        }
                        if (FeatureOrder.indexOf(b.GameType) >= 0) {
                            orderB += FeatureOrder.indexOf(b.GameType) * 100;
                        }
                    }
                    return a.OrderBy + orderA - (b.OrderBy + orderB);
                })
                .map(h => ({
                    hostId: h.HostId,
                    hallId: h.HallId,
                    gameType: h.GameType,
                }));
            outs.push(lobbySliceActions.updateHallGameTypeMap(hallGameTypeMap));
            return concat(outs);
        })
    );
